import { render, staticRenderFns } from "./ResultView.vue?vue&type=template&id=0400fff4&scoped=true&"
import script from "./ResultView.vue?vue&type=script&lang=js&"
export * from "./ResultView.vue?vue&type=script&lang=js&"
import style0 from "./ResultView.vue?vue&type=style&index=0&id=0400fff4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0400fff4",
  null
  
)

export default component.exports